import Link from "next/link"
import React from "react"
import { useLang } from "hooks/useLang"

export default function SmallFooter() {
    const { t } = useLang()

    return (
        <div className={`hidden w-full justify-between capitalize md:flex`}>
            <div className="flex gap-11">
                <Link
                    href={"/support/terms-of-use"}
                    passHref
                    className="cursor-pointer text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                    {t("USER_TAC_TITLE")}
                </Link>

                <Link
                    href={"/support/privacy-policy"}
                    passHref
                    className="cursor-pointer text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                    {t("privacy_policy_title")}
                </Link>
            </div>
            <div className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                © {new Date().getFullYear()} {t("all_rights_reserved")}
            </div>
        </div>
    )
}
